import * as React from 'react'
import { HereResult } from '@user/store/services/hereGeoCoder'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import Typography from '@mui/material/Typography'

type Props = {
  results: HereResult[]
  onResultClick: (result: HereResult) => void
  touched: boolean
}

export function SearchResults(props: Props): JSX.Element | null {
  const { onResultClick, results, touched } = props
  if (!touched || results === null) {
    return null
  }

  if (!results || results.length === 0) {
    return <Typography variant="body2">No Matches</Typography>
  }

  return (
    <List dense sx={{ py: 0, width: '100%' }}>
      {results.map((result, idx) => (
        <ListItemButton
          key={`${result.id}-${idx}`}
          sx={{ px: 1 }}
          onClick={() => onResultClick(result)}
        >
          <ListItemIcon sx={{ minWidth: 28, color: 'primary.main' }}>
            <LocationOnIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={result.address.label}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItemButton>
      ))}
    </List>
  )
}
